<template>
  <AdminConfirmModal
    v-model="getAcceptTestModal"
    :message="$t('Tariffs.sure_want_accept')"
    :confirm-text="$t('Default.accept')"
    @confirm="acceptTest"
  />
</template>
<script>
import { ref } from "@vue/composition-api";
import { DispatchTypes, MutationTypes } from "@/store/modules/tests/types";
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  props: ["currentTestInfo"],
  setup(props) {
    const store = useStore();

    const { userInfo } = globalVariables();

    const getAcceptTestModal = shortComputed(
      {
        storeType: "tests",
        key: "getAcceptTestModal",
      },
      MutationTypes.setAcceptTestModal
    );

    const payload = ref({
      status: 2,
    });

    const acceptTest = () => {
      store
        .dispatch(DispatchTypes.changeTestApplication, {
          id: props.currentTestInfo.id + "/",
          payload: payload.value,
        })
        .then(() => {
          store.commit(MutationTypes.setAcceptTestModal, false);
          store.dispatch(DispatchTypes.getTestApplication, "?status=" + 1);
        });
    };

    return {
      store,
      getAcceptTestModal,
      acceptTest,
      userInfo,
      payload,
    };
  },
};
</script>
